import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { UsersAppWebComponentSchema } from '../types';

export class UsersAppBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<UsersAppWebComponentSchema> {
    throw new Error('Not implemented');
  }
}
